<template>
	<article class="teaser teaser-news">
		<div
			class="teaser-news__cover"
			:class="{ 'teaser-news__cover-no-image': !imageSizes.length }"
		>
			<picture v-if="!imageSizes.length" class="teaser-news__image">
				<img :src="fallbackImage()" alt="" />
			</picture>
			<picture v-else class="teaser-news__image">
				<source :srcset="imageSrcSet" />
				<img :src="imageSizes[0]" alt="" />
			</picture>
		</div>
		<div class="teaser-news__body">
			<h2 class="teaser-news__title heading--4">
				<a class="teaser__title-link" :href="link" :html="formattedTitle">{{
					formattedTitle
				}}</a>
			</h2>
			<div class="teaser-news__date">{{ postDate | dateFilter }}</div>
		</div>
	</article>
</template>
<script>
import { store } from "./store.js";
export default {
	name: "NewsTeaser",
	props: ["title", "link", "imageSizes", "postDate"],
	data() {
		return {
			imageSrcSet: null,
		};
	},
	computed: {
		formattedTitle() {
			const parser = new DOMParser();
			const decodedTitle = parser.parseFromString(
				`<!doctype html><body>${this.title}`,
				"text/html"
			).body.textContent;
			return decodedTitle.replace("&amp;", "&");
		},
	},
	mounted: function () {
		if (this.imageSizes) {
			this.imageSrcSet = this.imageSizes
				.map((src, index) => {
					if (index == 0) {
						return `${src} 1x`;
					} else if (index === 1) {
						return `, ${src} 2x`;
					}
				})
				.join(" ");
		}
	},
	filters: {
		dateFilter(value) {
			const date = new Date(value);
			const options = {
				day: "numeric",
				month: "long",
				year: "numeric",
			};
			return date.toLocaleDateString("nl-NL", options).toLowerCase();
		},
	},
	methods: {
		fallbackImage() {
			return `${window.THEME_LINK}/${store.newsTeaserFallbackImage}`;
		},
	},
};
</script>
